const ViewAttribute = ({ edit }) => {

  return (
    <div className="px-1">
      <table className="table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Is Included In CF</th>
          </tr>
        </thead>
        <tbody>
          {edit?.attributes?.map((option, index) => (
            <tr key={option.id}>
              <td>{option.title}</td>
              <td style={{ color: 'red' }}>No</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewAttribute;
